import type {
  AccountRepresentativeListModel,
  AccountRepresentativeModel,
} from '../app/types/account-representative.type.ts';
import baseApi, { CacheTag } from './meeting-md-api-slice';

const accountRepresentativeApiSlice = baseApi.injectEndpoints({
  endpoints: builder => ({
    requestAccess: builder.mutation<AccountRepresentativeModel, { accountKey: string }>({
      query: ({ accountKey }) => ({
        url: `AccountRepresentative/RequestAccess?accountKey=${accountKey}`,
        method: 'POST',
      }),
      invalidatesTags: [CacheTag.AccountReps],
    }),
    putAccountRepresentative: builder.mutation<
      AccountRepresentativeModel,
      AccountRepresentativeModel
    >({
      query: put => ({
        url: 'AccountRepresentative',
        method: 'PUT',
        body: put,
      }),
      invalidatesTags: [CacheTag.AccountReps],
    }),
    fetchAccountRepresentativesForLoggedInRepresentative: builder.query<
      AccountRepresentativeListModel[],
      void
    >({
      query: () => ({ url: 'AccountRepresentative/ForLoggedInRepresentative' }),
      providesTags: [CacheTag.AccountReps],
    }),
    fetchAccountRepresentativesForAccount: builder.query<AccountRepresentativeListModel[], string>({
      query: key => ({ url: `AccountRepresentative/Account/${key}` }),
      providesTags: [CacheTag.AccountReps],
    }),
    fetchAccountRepresentative: builder.query<AccountRepresentativeModel, string>({
      query: key => ({ url: `AccountRepresentative/${key}` }),
      providesTags: [CacheTag.AccountReps],
    }),
    patchToggleFavoriteAccountRepresentative: builder.mutation<void, string>({
      query: key => ({
        url: `AccountRepresentative/ToggleFavorite/${key}`,
        method: 'PATCH',
      }),
      invalidatesTags: [CacheTag.AccountReps],
    }),
    patchSetRatingAccountRepresentative: builder.mutation<void, { key: string; rate: number }>({
      query: obj => ({
        url: `AccountRepresentative/SetRating/${obj.key}/${obj.rate}`,
        method: 'PATCH',
      }),
      invalidatesTags: [CacheTag.AccountReps],
    }),
    patchApproveAccountRepresentative: builder.mutation<void, string>({
      query: key => ({
        url: `AccountRepresentative/Approve/${key}`,
        method: 'PATCH',
      }),
      invalidatesTags: [CacheTag.AccountReps],
    }),
    patchRejectAccountRepresentative: builder.mutation<void, string>({
      query: key => ({
        url: `AccountRepresentative/Reject/${key}`,
        method: 'PATCH',
      }),
      invalidatesTags: [CacheTag.AccountReps],
    }),
    attachAccountRepresentative: builder.mutation<
      void,
      { accountKey: string; representativeKey: string }
    >({
      query: ({ accountKey, representativeKey }) => ({
        url: `AccountRepresentative/Attach?accountKey=${accountKey}&representativeKey=${representativeKey}`,
        method: 'POST',
      }),
      invalidatesTags: [CacheTag.AccountReps],
    }),
  }),
});

export const {
  useRequestAccessMutation,
  usePutAccountRepresentativeMutation,
  useFetchAccountRepresentativesForLoggedInRepresentativeQuery,
  useFetchAccountRepresentativesForAccountQuery,
  useFetchAccountRepresentativeQuery,
  usePatchApproveAccountRepresentativeMutation,
  usePatchRejectAccountRepresentativeMutation,
  usePatchSetRatingAccountRepresentativeMutation,
  usePatchToggleFavoriteAccountRepresentativeMutation,
  useAttachAccountRepresentativeMutation,
} = accountRepresentativeApiSlice;
